import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        dateRange: {
            start: "2025-09-01",
            end: "2025-09-30"
        }
    },
    mutations: {
        setDateRange(state, payload) {
            state.dateRange = payload;
        }
    },
    actions: {
        updateDateRange({ commit }, payload) {
            commit("setDateRange", payload);
        }
    },
    modules: {}
});
